// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__dBvqE","inner":"carousel_inner__CEtR0","carouselItem":"carousel_carouselItem__Z8wIR"};